import { toast } from 'react-toastify';
import { Action } from 'redux';
import { selectMapLabels } from 'store/labels';
import { select } from 'typed-redux-saga';
import { calcRequestLabel } from 'utils/other';
import { parseErrorData } from 'utils/services';

export const combineActions = <R, S, F>(request: R, success: S, fail: F) => {
  return { request, success, fail };
};

interface ThunkAction<E extends { message: string }> extends Action<string> {
  error: E;
}
export function* workerErrorNotifyThunk<T extends ThunkAction<Error>>(data: T) {
  if (data.error) {
    yield* notifyErrorSaga(data.error);
  }
}

interface SagaAction<E extends { message: string }> extends Action<any> {
  payload: { error: E };
}
export function* workerErrorNotifySaga<T extends SagaAction<Error>>(action: T) {
  if (action?.payload?.error) {
    yield* notifyErrorSaga(action.payload.error);
  }
}

export function* notifyErrorSaga(e: { message: string }) {
  const error = parseErrorData(e);
  const mapLabels = yield* select(selectMapLabels);

  const title = calcRequestLabel(error.message, (key) => {
    return mapLabels[key]?.title || key;
  });

  yield toast.error(title);
}
export function* notifySuccessSaga(message: string) {
  const mapLabels = yield* select(selectMapLabels);

  const title = calcRequestLabel(message, (key) => {
    return mapLabels[key]?.title || key;
  });

  yield toast.success(title);
}

export const combineAction = <R, S, F>(pending: R, fulfilled: S, rejected: F) => {
  return { pending, fulfilled, rejected };
};
